module.exports = __webpack_public_path__ + "img/rullet_wgoods.152533ad.png";